import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=553d4617"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"
import style0 from "./welcome.vue?vue&type=style&index=0&id=553d4617&prod&lang=css"
import style1 from "./welcome.vue?vue&type=style&index=1&id=553d4617&prod&lang=css"
import style2 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports